import $ from 'jquery';

export const bsTooltip = {
    beforeMount(el, binding) {
        if (binding.value === null || binding.value === undefined) {
            return;
        }
        const opts = typeof binding.value === 'string' ? { title: binding.value } : binding.value;
        $(el).tooltip(opts);
    },
    updated(el, binding) {
        bsTooltip.unmounted(el, binding);
        bsTooltip.beforeMount(el, binding);
    },
    unmounted(el) {
        $(el).tooltip('dispose');
    },
};
